import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import { compact } from 'lodash';

import { dispatchRestMaker } from 'helpers/utils';
import immutableToJS from 'helpers/immutableToJS';
import sellersActions from 'redux/sellers/actions';
import { selectState } from 'redux/selectors';
import ContactsList from './ContactsList';

export const withSellers = (CardComp, hasWarehouse = false, org = null) => {
  class Sellers extends Component {
    static propTypes = {
      sellerRequesting: PropTypes.bool.isRequired,
      sellers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
        }),
      ).isRequired,
      sellersRequesting: PropTypes.bool.isRequired,
      updateSeller: PropTypes.func.isRequired,

      createSeller: PropTypes.func.isRequired,
      listSellers: PropTypes.func.isRequired,
      readSeller: PropTypes.func.isRequired,
      removeSeller: PropTypes.func.isRequired,
    };

    render() {
      const {
        sellerRequesting,
        sellersRequesting,
        sellers,
        updateSeller,
        createSeller,
        listSellers,
        readSeller,
        removeSeller,
        ...restProps
      } = this.props;
      
      const contacts = compact(sellers.concat([hasWarehouse && {id: 0,}]));
      
      // distributor/farm is a member of a restaurant and place orders on behalf of the restaurant they only see their own catalog 
      const contactsFiltered = (org && contacts.length != 0) ? contacts.filter(c => c.sellerProfile.id === parseInt(org,10)) : contacts;

      return (
        <ContactsList
          addFormTitle="Add Vendor"
          addTooltip="Add New Vendor"
          CardComp={CardComp}
          contactProfileKey="sellerProfile"
          contactRequesting={sellerRequesting}
          contacts={contactsFiltered.length ? contactsFiltered : []}
          contactsRequesting={sellersRequesting}
          label={['A-Z', 'Group']}
          onCreateContact={createSeller}
          onListContacts={listSellers}
          onReadContact={readSeller}
          onRemoveContact={removeSeller}
          onUpdateContact={updateSeller}
          searchTooltip="Search Vendors"
          title="Order"
          {...restProps}
        />
      );
    }
  }

  const mapStateToProps = state => ({
    ...selectState('sellers', 'seller')(state, 'seller'),
    ...selectState('sellers', 'sellers')(state, 'sellers'),
  });

  return compose(
    setDisplayName('Sellers'),
    connect(
      mapStateToProps,
      dispatchRestMaker([
        [sellersActions, 'seller'],
      ]),
    ),
    immutableToJS,
  )(Sellers);
};

export default withSellers;
